module.exports = __webpack_public_path__ + "static/media/LoginPageAvatarImage09.097eba96.webp";